import ZipIcon from '@isbj-redesign/icons/FaFileArchiveLight'
import CodeIcon from '@isbj-redesign/icons/FaFileCodeLight'
import CsvIcon from '@isbj-redesign/icons/FaFileCsvLight'
import ExcelIcon from '@isbj-redesign/icons/FaFileExcelLight'
import WordIcon from '@isbj-redesign/icons/FaFileWordLight'
import ImageIcon from '@isbj-redesign/icons/FaFileImageLight'
import GenericIcon from '@isbj-redesign/icons/FaFileLight'
import PdfIcon from '@isbj-redesign/icons/FaFilePdfLight'
import PowerpointIcon from '@isbj-redesign/icons/FaFilePowerpointLight'
import IconProps from '@isbj-redesign/icons/props'
import React, { ComponentType } from 'react'

const excel = { icon: ExcelIcon, label: 'Excel' }
const word = { icon: WordIcon, label: 'Word' }
const powerpoint = { icon: PowerpointIcon, label: 'Powerpoint' }

const mapping: { [type: string]: { icon: ComponentType<IconProps>; label: string } } = {
    'application/pdf': { icon: PdfIcon, label: 'PDF' },
    'application/zip': { icon: ZipIcon, label: 'ZIP' },
    'application/vnd.ms-excel': excel,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': excel,
    'application/vnd.oasis.opendocument.spreadsheet': excel,
    'application/vnd.ms-powerpoint': powerpoint,
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': powerpoint,
    'application/vnd.oasis.opendocument.presentation': powerpoint,
    'application/msword': word,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': word,
    'application/vnd.oasis.opendocument.document': word,
    'application/rtf': { icon: WordIcon, label: 'Rich Text Format' },
    'text/csv': { icon: CsvIcon, label: 'CSV' },
    'text/html': { icon: CodeIcon, label: 'HTML' },
    'image/png': { icon: ImageIcon, label: 'PNG' },
    'image/jpeg': { icon: ImageIcon, label: 'JPEG' },
}

export type FileIconProps = {
    type: string
    className?: string
}

export function FileIcon({ type, className }: FileIconProps) {
    const { icon: Icon, label } = mapping[type] || { icon: GenericIcon, label: type }

    return <Icon className={className} title={label} />
}

export type FileLabelProps = {
    type: string
}

export function FileLabel({ type }: FileLabelProps) {
    const { label } = mapping[type] || { label: type }
    return <>{label}</>
}
